import { render, staticRenderFns } from "./OrgSelection.vue?vue&type=template&id=f2e9afe4&"
import script from "./OrgSelection.vue?vue&type=script&lang=js&"
export * from "./OrgSelection.vue?vue&type=script&lang=js&"
import style0 from "./OrgSelection.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports